module.exports = __webpack_public_path__ + "static/img/zhifubao.4e1f9b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhifubao.png
// module id = A/aW
// module chunks = 1